document.addEventListener("DOMContentLoaded", function () {
  var isDesktop = window.innerWidth > 780;
  if (!isDesktop) {
    // Sticky header composition
    var header = document.querySelector("header.cwr-header");
    var stickyNavigation = document.querySelector("section.main-nav");
    var announceBar = document.querySelector(
      "#shopify-section-cwr-announcement,#shopify-section-cwr-announcement-spanish"
    );
    var headerContainer = document.querySelector("#shopify-section-cwr-header,#shopify-section-cwr-header-spanish");

    // Unite the header
    if(announceBar){
      headerContainer.prepend(announceBar);
    }

    var announceBarCustomNew = document.querySelector(".custon-made-new-announcement .cwr-announcement");
    var headerContainerCustomNew = document.querySelector(".custon-made-new-header");
    if(announceBarCustomNew){
      headerContainerCustomNew.prepend(announceBarCustomNew);
    }

    // Insert the navigation after the header
    header.parentNode.insertBefore(stickyNavigation, header.nextSibling);

    var navContainer = document.querySelector("section.main-nav");

    // Handle the header styles through scroll positioning
    if(navContainer){
      window.addEventListener("scroll", function () {
        var scrollPos = window.scrollY;

        if (scrollPos > 20) {
          navContainer.classList.add("visible");
          header.classList.add("fixed-styles");
        } else {
          navContainer.classList.remove("visible");
          header.classList.remove("fixed-styles");
        }
      });
    }

    var pricesFormContainer = document.querySelector(
      "div.cwr-product-details__content"
    );
    pricesFormContainer.setAttribute("id", "currency");

    // Scroll to x position based on # from a section
    document.querySelectorAll(".main-nav__link").forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        var sectionId = this.getAttribute("href").replace("#", "");

        var sectionElement = document.getElementById(sectionId);
        if (sectionElement) {
          var targetPosition =
            sectionElement.offsetTop -
            document.querySelector("header.cwr-header").offsetHeight -
            50;
          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        } else {
          console.warn("Section with id " + sectionId + " could not be found.");
        }
      });
    });
  }
});